// Who may do what. One permission per action; PERMS gives each role its list. The screens (menus, buttons, pages)
// and the API (the fixture now, the backend later) check the same words. SPEC §11: admin = everything; campaign
// manager = edit + run; approver = approve (never their own campaign, vendor change or voice message); analyst =
// read only.
import type { Role } from '@/api/schemas'

export const PERMISSION = {
  channelsEdit: 'channels.edit',
  sourcesFetch: 'sources.fetch',
  suppressionAdd: 'suppression.add',
  suppressionRemove: 'suppression.remove',
  audiencesEdit: 'audiences.edit',
  workflowsEdit: 'workflows.edit',
  campaignsEdit: 'campaigns.edit',
  campaignsRun: 'campaigns.run',
  campaignsApprove: 'campaigns.approve',
  /** W1 (R6): the list of people left out of an audience, with the reason (admin only) */
  removedPeopleSee: 'campaigns.removed_people',
  vendorsEdit: 'vendors.edit',
  /** a second person approves a change on a live vendor (never their own) */
  vendorsApprove: 'vendors.approve',
  /** a second person approves a voice message (never their own); its words then become consent wording */
  voiceApprove: 'voice.approve',
  settingsEdit: 'settings.edit',
  usersManage: 'users.manage',
} as const
export type Permission = (typeof PERMISSION)[keyof typeof PERMISSION]

const P = PERMISSION
export const PERMS: Record<Role, readonly Permission[]> = {
  admin: Object.values(PERMISSION),
  campaign_manager: [
    P.channelsEdit,
    P.sourcesFetch,
    P.suppressionAdd,
    P.audiencesEdit,
    P.workflowsEdit,
    P.campaignsEdit,
    P.campaignsRun,
  ],
  approver: [P.campaignsApprove, P.vendorsApprove, P.voiceApprove],
  analyst: [],
}

export function userCan(user: { role: Role } | null | undefined, permission: Permission): boolean {
  if (!user) return false
  return PERMS[user.role].includes(permission)
}
